export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
export const CLOUDINARY_CLOUD_NAME = import.meta.env.VITE_CLOUDINARY_CLOUD_NAME;
export const PARENT_APP_BASE_URL = import.meta.env.VITE_P_AND_O_WEBSITE_LINK;
